import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'irembogov-custom-image',
  templateUrl: './custom-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomImageComponent extends FieldType<FieldTypeConfig> {}
